import React from 'react';
import { ModalFuncProps, Radio } from 'antd';
import { formatUnit } from '../../utils/units';

export type OrderPdfConversionUnit = 'pcs' | 'm2' | 'm3';

// 'none' = operator explicitly wants no additional conversion column
// (e.g. windows); null = the modal was cancelled, so no download happens.
export type OrderPdfConversionChoice = OrderPdfConversionUnit | 'none';

type ConfirmModal = {
  confirm: (config: ModalFuncProps) => void;
};

type Translate = (key: string) => string;

export function promptOrderPdfConversionUnit(
  modal: ConfirmModal,
  t: Translate,
): Promise<OrderPdfConversionChoice | null> {
  return new Promise<OrderPdfConversionChoice | null>((resolve) => {
    let selectedChoice: OrderPdfConversionChoice = 'm2';
    modal.confirm({
      title: t('orders:orderDetail.additionalDimensionPrompt'),
      content: (
        <Radio.Group
          defaultValue={selectedChoice}
          onChange={(event) => {
            selectedChoice = event.target.value as OrderPdfConversionChoice;
          }}
          optionType="button"
          buttonStyle="solid"
          style={{ marginTop: 8 }}
        >
          <Radio.Button value="pcs">{formatUnit('pcs')}</Radio.Button>
          <Radio.Button value="m2">{formatUnit('m2')}</Radio.Button>
          <Radio.Button value="m3">{formatUnit('m3')}</Radio.Button>
          <Radio.Button value="none">{t('orders:orderDetail.additionalDimensionNone')}</Radio.Button>
        </Radio.Group>
      ),
      okText: t('orders:orderDetail.additionalDimensionDownload'),
      cancelText: t('common:cancel'),
      onOk: () => resolve(selectedChoice),
      onCancel: () => resolve(null),
    });
  });
}
